import React from 'react';
import { FieldWrapper } from '@progress/kendo-react-form';
import { Label, Error } from '@progress/kendo-react-labels';
import BaseInput from '../inputs/BaseInput';

/**
 * @deprecated Use /shared/components/formControls components instead.
 */
const FormInput = React.forwardRef((fieldRenderProps, ref) => {
  const {
    validationMessage,
    visited,
    label,
    id,
    valid,
    disabled,
    type,
    optional,
    readOnly,
    inputComponent = BaseInput,
    wrapperClassName,
    stopWheel = true,
    noWrapper = false,
    horizontal = true,
    ...others
  } = fieldRenderProps;

  const showValidationMessage = visited && validationMessage;
  const errorId = showValidationMessage ? `${id}_error` : '';
  const InputComponent = inputComponent;

  const handleStopWheel = (event) => {
    event?.stopPropagation();
  };

  const innerRef = React.useRef(null);
  React.useImperativeHandle(ref, () => innerRef?.current);
  React.useEffect(() => {
    if (stopWheel) {
      innerRef.current?.element?.addEventListener('wheel', handleStopWheel);
    } else {
      innerRef.current?.element?.removeEventListener('wheel', handleStopWheel);
    }
    return () => {
      innerRef.current?.element?.removeEventListener('wheel', handleStopWheel);
    };
  }, [stopWheel]);

  const content = (
    <>
      <Label
        editorId={id}
        editorValid={valid}
        editorDisabled={disabled}
        optional={optional}
        {...(readOnly ? { className: 'label-readonly' } : {})}
      >
        {label}
      </Label>
      <InputComponent
        valid={valid}
        type={type}
        id={id}
        disabled={disabled}
        ariaDescribedBy={errorId}
        readOnly={readOnly}
        ref={innerRef}
        {...others}
      />
      {showValidationMessage && (
        <Error id={errorId}>{validationMessage}</Error>
      )}
    </>
  );

  if (noWrapper) {
    return <div className={horizontal ? 'k-form-field' : 'k-form-field-wrapper'}>{content}</div>;
  }

  return <FieldWrapper className={wrapperClassName}><div className="k-form-field-wrap">{content}</div></FieldWrapper>;
});

export default FormInput;
